import { ISessionStats } from '../types';
import createEmptyStatsWrapper from './create-empty-stats-wrapper';

const createEmptySessionStats: () => ISessionStats = () => ({
  SessionViews: createEmptyStatsWrapper(),
  SessionAllChartData: createEmptyStatsWrapper(),
  AverageSessionWatchtimes: createEmptyStatsWrapper(),
  SessionPageViews: createEmptyStatsWrapper(),
  SessionUniqueAttendance: createEmptyStatsWrapper(),
  SessionRetentionTimeline: createEmptyStatsWrapper(),
  SessionUserSurvey: createEmptyStatsWrapper(),
  Session90SecondVideoViewers: createEmptyStatsWrapper(),
  SessionReactions: createEmptyStatsWrapper(),
  SessionEngagement: createEmptyStatsWrapper(),
  ActualSessionStartTime: createEmptyStatsWrapper(),
});

export default createEmptySessionStats;
